import React from 'react';

import { Button } from '@components/Button';
import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { Stepper } from '@components/Stepper';
import { steps } from '@data/membershipForm';
import { useEnabledSteps } from '@pages/utilities/MembershipForm/helpers';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '完了',
    thankYou: 'ありがとうございました！',
    body: 'D2D MEMBERSにお申込み頂きありがとうございます。\n3営業日以内に、D2Dカスタマーサービスよりご連絡申し上げます。\nどうぞ宜しくお願い致します。',
    goBack: 'TOPへ戻る',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  buttons: {
    ...common.flexInline,
    justifyContent: 'center',
  },
  button: {
    width: 200,
  },
  thankYou: {
    ...common.biggerText,
    marginTop: '2rem',
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
    fontWeight: 500,
    textAlign: 'center',
  },
  body: {
    ...common.bigText,
    color: theme.palette.grey['700'],
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    fontWeight: 500,
    padding: '2.5rem 0',
  },
}));

export const Complete: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const enabledSteps = useEnabledSteps();

  return (
    <Layout title={strings.title}>
      <Container>
        <Stepper steps={steps} value={steps[4].name} enabledSteps={enabledSteps} />
        <div className={classes.thankYou}>{strings.thankYou}</div>

        <div className={classes.body}>{strings.body}</div>

        <div className={classes.buttons}>
          <a href="/utilities/Dashboard">
            <Button text={strings.goBack} color="primary" className={classes.button} />
          </a>
        </div>
      </Container>
    </Layout>
  );
};
